



(() => {
  async function addVariant(variantId) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
  }

  function getSectionId() {
    const comp = document.querySelector('cart-items-component[data-section-id]');
    return comp ? comp.getAttribute('data-section-id') : null;
  }

  async function fetchSectionHTML(sectionId) {
    const url = `/?sections=${encodeURIComponent(sectionId)}`;
    const res = await fetch(url, { headers: { 'Accept': 'application/json' } });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
  }

  function replaceDrawerInner(htmlString) {
    // Replace only the drawer inner content to keep dialog open and JS bindings stable
    const dialog = document.querySelector('[data-ilse-cart-dialog]');
    if (!dialog) return;

    const temp = document.createElement('div');
    temp.innerHTML = htmlString;

    // In Horizon, section HTML includes the whole snippet markup.
    // We target the cart drawer dialog inner block:
    const newInner = temp.querySelector('.cart-drawer__inner');
    const currentInner = dialog.querySelector('.cart-drawer__inner');

    if (newInner && currentInner) {
      currentInner.replaceWith(newInner);
    }
  }

  function fireThemeEvents() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:update'));
    document.dispatchEvent(new CustomEvent('cart:changed'));
  }

  async function refreshDrawer() {
    const sectionId = getSectionId();
    if (!sectionId) {
      fireThemeEvents();
      return;
    }

    try {
      const json = await fetchSectionHTML(sectionId);
      const html = json && json[sectionId];
      if (html) {
        replaceDrawerInner(html);
        fireThemeEvents();
      } else {
        fireThemeEvents();
      }
    } catch (e) {
      console.error(e);
      fireThemeEvents();
    }
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.ilse-upsell__btn[data-add]');
    if (!btn) return;

    const item = btn.closest('[data-variant-id]');
    const variantId = item && item.getAttribute('data-variant-id');
    if (!variantId) return;

    const old = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Ajout…';

    try {
      await addVariant(variantId);
      btn.textContent = 'Ajouté ✓';
      await refreshDrawer();

      setTimeout(() => {
        btn.textContent = old;
        btn.disabled = false;
      }, 700);
    } catch (err) {
      console.error(err);
      btn.textContent = old;
      btn.disabled = false;
    }
  });
})();
